import { useEffect, useCallback, useRef } from 'react';
type EventType = 'page_view' | 'link_click' | 'view_switch';
/** Anonymous counts. The server holds a short-lived pseudonymous abuse bucket. */
export async function trackEvent(event_type: EventType, event_target = '', page_path = '/', link_id?: string): Promise<void> {
  try {
    if (page_path !== '/' && page_path !== '/redesign') return;
    const body = { event_type, event_target: event_target.slice(0, 200), page_path,
      ...(link_id && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(link_id) ? { link_id } : {}) };
    await fetch('/api/analytics-track', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body), keepalive: true });
  } catch { /* Analytics must never interfere with navigation. */ }
}
export function useAnalytics(pagePath = '/', enabled = true) {
  const tracked = useRef<string | null>(null);
  useEffect(() => {
    if (!enabled || tracked.current === pagePath) return;
    tracked.current = pagePath; void trackEvent('page_view', '', pagePath);
  }, [pagePath, enabled]);
  const trackClick = useCallback((title: string, id?: string) => { if (enabled) void trackEvent('link_click', title, pagePath, id); }, [pagePath, enabled]);
  const trackViewSwitch = useCallback((viewName: string) => { if (enabled) void trackEvent('view_switch', viewName, pagePath); }, [pagePath, enabled]);
  return { trackClick, trackViewSwitch };
}
